/* eslint-disable no-unused-vars */
import axios from "axios";
import swal from "sweetalert";
import { loginConfirmedAction, Logout } from "../store/actions/AuthActions";
import config from "../../config.json";
import { getAuthToken } from "../utils/authToken";

export async function loginSA(email, password) {
  return axios
    .post(`${config.dev}/auth/login`, { email, password })
    .then((response) => response.data)
    .catch((error) => {
      // rejette l'erreur pour la propager au catch du loginAction
      return Promise.reject(error);
    });
}

export async function verify2FALogin(tempToken, code, method = "authenticator") {
  return axios
    .post(`${config.dev}/auth/verify-2fa`, { tempToken, code, method })
    .then((response) => response.data);
}

export async function sendLogin2FAEmailCode(tempToken) {
  return axios
    .post(`${config.dev}/auth/2fa/send-login-code`, { tempToken })
    .then((response) => response.data);
}

export async function setup2FA() {
  const response = await axios.post(
    `${config.dev}/auth/2fa/setup`,
    {},
    {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    }
  );
  return response.data;
}

export async function enable2FA(code) {
  const response = await axios.post(
    `${config.dev}/auth/2fa/enable`,
    { code },
    {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    }
  );
  return response.data;
}

export async function disable2FA(code, currentPassword) {
  const response = await axios.post(
    `${config.dev}/auth/2fa/disable`,
    { code, currentPassword },
    {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    }
  );
  return response.data;
}

export async function userProfile() {
  try {
    const response = await axios.get(`${config.dev}/user/v2/userData`, {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la récupération des données utilisateur :",
      error
    );
    throw error;
  }
}

export async function fetchRestaurantData(id) {
  try {
    const response = await axios.get(
      `${config.dev}/auth/restaurant-data/${id}`,
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      }
    );

    console.log("user to get", response.data);

    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la récupération des données utilisateur :",
      error
    );
    throw error;
  }
}

export function signUp(email, password) {
  //axios call
  const postData = {
    email,
    password,
    returnSecureToken: true,
  };
  return axios.post(
    `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
    postData
  );
}

export function login(email, password) {
  const postData = {
    email,
    password,
    returnSecureToken: true,
  };
  return axios.post(
    `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
    postData
  );
}

export function formatError(errorResponse) {
  switch (errorResponse.error.message) {
    case "EMAIL_EXISTS":
      //return 'Email already exists';
      swal("Oops", "Email already exists", "error");
      break;
    case "EMAIL_NOT_FOUND":
      //return 'Email not found';
      swal("Oops", "Email not found", "error", { button: "Try Again!" });
      break;
    case "INVALID_PASSWORD":
      //return 'Invalid Password';
      swal("Oops", "Invalid Password", "error", { button: "Try Again!" });
      break;
    case "USER_DISABLED":
      return "User Disabled";

    default:
      return "";
  }
}

export function saveTokenInLocalStorage(tokenDetails) {
  tokenDetails.expireDate = new Date(
    new Date().getTime() + tokenDetails.expiresIn * 1000
  );
  localStorage.setItem("userDetails", JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, navigate) {
  setTimeout(() => {
    //dispatch(Logout(history));
    dispatch(Logout(navigate));
  }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
  const tokenDetailsString = localStorage.getItem("tokenLogin");
  let tokenDetails = "";
  if (!tokenDetailsString) {
    dispatch(Logout(navigate));
    return;
  }

  tokenDetails = JSON.parse(tokenDetailsString);
  let expireDate = new Date(tokenDetails.expireDate);
  let todaysDate = new Date();

  if (todaysDate > expireDate) {
    dispatch(Logout(navigate));
    return;
  }

  dispatch(loginConfirmedAction(tokenDetails));

  const timer = expireDate.getTime() - todaysDate.getTime();
  runLogoutTimer(dispatch, timer, navigate);
}

export function isLogin() {
  const tokenDetailsString = localStorage.getItem("userDetails");

  if (tokenDetailsString) {
    return true;
  } else {
    return false;
  }
}

export const updateUserData = async (data) => {
  try {
    const token = getAuthToken();

    const response = await axios.put(
      `${config.dev}/user/updateUser-data`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.message;
  } catch (err) {
    console.error(err);
    alert("Une erreur est survenue.");
  }
};


export async function fetchRestoDataByUser() {
  try {
    const token = getAuthToken();

    if (!token) {
      throw new Error("Authentication token is missing.");
    }

    const response = await axios.get(
      `${config.dev}/v2/restaurant/data-by-user`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error while fetching restaurant data:", error);
    throw error.response?.data || { message: "An unknown error occurred." };
  }
}
